<template>
  <div class="fyApplyResult">
    <Header title="复议申请结果" type="0" route="/fyApply/index"></Header>
    <NOdata
      v-if="this.list && this.list.length == 0"
      title="未查询到复议申请结果"
    ></NOdata>
    <div v-else class="content">
      <div class="list">
        <div
          class="list-item update"
          v-for="(item, index) of list"
          :key="index"
        >
          <p>{{ item.kcmc }}[{{ item.kcbh }}]</p>
          <ul>
            <li>申请时间：{{ item.sqsj }}</li>
            <li>申请原因：{{ item.sqyy }}</li>
            <li>总学时：{{ item.zxs }}</li>
            <li>学分：{{ item.xf }}</li>
            <!-- <li v-if="item.value != '报名'" :class="item.class">
              状态：{{ item.text }}}
            </li> -->
          </ul>
          <span :class="item.class">
            {{ item.shzt }}
          </span>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

import Vue from "vue";
import { Picker } from "vant";

Vue.use(Picker);
export default {
  data() {
    return {
      show: false,
      valueList: {
        label: "",
        value: "",
        item: []
      },
      list: [],
      columns: {}
    };
  },
  methods: {
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    },
    async getList() {
      const res = await Api.cjfh_list();
      if (res.data.cjfhsqjl.length > 0) {
        this.list = res.data.cjfhsqjl.map(item => {
          if (item.shzt === "未通过") {
            item.class = "btgClass";
          } else if (item.shzt === "已通过") {
            item.class = "ytgClass";
          } else if (item.shzt === "待送审") {
            item.class = "dssClass";
          } else {
            item.class = "shzClass";
          }
          return item;
        });
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.fyApplyResult {
  .content {
    padding: 0 5% 10px;
    .list {
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
          height: 22px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
      }

      .update span {
        height: 20px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        letter-spacing: 0;
        position: absolute;
        top: calc(50% - 10px);
        right: 5%;
        font-weight: bolder;
      }
      .shzClass {
        color: #7469f8;
      }
      .btgClass {
        color: #f86969;
      }
      .ytgClass {
        color: #12ddd6;
      }
      .dssClass {
        color: #757da3;
      }
      .bmClass {
        width: 70px;
        height: 42px !important;
        top: calc(50% - 21px) !important;
        background: #7469f8;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
      .qxbmClass {
        width: 70px;
        height: 42px !important;
        top: calc(50% - 21px) !important;
        background: #f7e3e3;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #f86969;
      }
    }
  }
  .icon {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/fyApply/result.vue